<template>
	<el-dialog :visible.sync="showcargosort" :title="title" width="400px" :append-to-body="true" :close-on-click-modal="false">
		<el-row>
			<el-col :span="24">
				<el-select
					style="width:97%;"
					v-model="selecteditem"
					multiple
					filterable
					default-first-option
					size="mini"
					:placeholder="'请选择' + title"
				>
					<el-option v-for="item in options" :key="item.label" :label="item.label" :value="item.id"></el-option>
				</el-select>
			</el-col>
		</el-row>
		<span slot="footer" class="dialog-footer">
			<div style="text-align:center;width:100%;padding-top:10px">
				<el-button size="mini" type="success" @click.native="savesortbind">保存</el-button>
				<el-button size="mini" style="margin-left:10px" type="info" plain @click.native="showcargosort = false">关闭</el-button>
			</div>
		</span>
	</el-dialog>
</template>

<script>
export default {
	props: {},
	data() {
		return {
			showcargosort: false,
			title: '',
			p_sort: '', //商品分类名称
			divclass: 'inputBox',
			type: '',
			options: [],
			selecteditem: [],
			cargotype:'',
			lang:''
		};
	},
	methods: {
		init(param) {
			this.showcargosort = true;
			this.selecteditem=[];
			this.options=[];
			this.lang='';
			this.type='';
			this.cargotype='';
			this.p_sort='';
			
			if (param.title != undefined) this.title = param.title;
			if (param.type != undefined) this.type = param.type;
			if (param.p_sort != undefined) this.p_sort = param.p_sort; //商品分类
			if(param.cargotype!=undefined) this.cargotype=param.cargotype;
			if(param.lang!=undefined) this.lang=param.lang;
			this.loadSelectItem();
		},
		//获取所有的项目
		loadSelectItem(p_sort) {
			var that=this;
			if(p_sort==undefined)
				p_sort='';
			var paraminfo={
				p_sort:p_sort,
				cargotype:this.cargotype,
				lang:this.lang
			}
			var method='';
			if(this.type=='1')
				method='GetCargoBrand_SC';
			else
				method='GetSpce_SC';
			this.$tool.loading('正在加载', this.divclass);
			this.$apipost.get[method]({paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				if(res.state=='1'){
					if(p_sort==''){
						that.options=res.list;
						that.loadSelectItem(that.p_sort);
					}
					else{
						var list=res.list;
						list.forEach(e=>{
							that.selecteditem.push(e.id);	
						});
					}
				}
			});
		},
		//保存商品分类绑定
		savesortbind() {
			//console.log(this.selecteditem);
			if(this.selecteditem.length==0)
			{
				this.$tool.message('请选择绑定项目', 0);
				return false;
			}	
			var that=this;
			var paraminfo={
				p_sort:this.p_sort,
				type:this.type,
				ids:this.selecteditem.join(','),
				cargotype:this.cargotype
			}
			//return false;
			this.$tool.loading('正在绑定', this.divclass);
			this.$apipost.post.BindSort({paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				if(res.state=='1'){
					this.$tool.message('绑定成功', 1);
					that.showcargosort=false;
				}
				else
					this.$tool.message(res.message, 0);
			});
		}
	}
};
</script>

<style></style>
